const escapeCss = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
    }
    // simple fallback
    return String(value).replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1');
};

const findModalForTrigger = (trigger, modalId) => {
    // Try to find the modal inside one of trigger's ancestors first (handles duplicated IDs per card/slide)
    let current = trigger;
    while (current) {
        const scoped = current.querySelector && current.querySelector(`#${escapeCss(modalId)}`);
        if (scoped) return scoped;
        current = current.parentElement;
    }
    // Fallback to global by id
    return document.getElementById(modalId);
};

const setBodyScrollLocked = (locked) => {
    document.body.classList.toggle('overflow-hidden', locked);
};

const openModals = new Set();

const hideModalElement = (modalEl) => {
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.setAttribute('hidden', '');
};

const showModalElement = (modalEl) => {
    modalEl.removeAttribute('hidden');
    modalEl.setAttribute('aria-hidden', 'false');
    modalEl.classList.add('is-open');
};

const openModal = (modalEl) => {
    if (!modalEl) return;
    showModalElement(modalEl);
    openModals.add(modalEl);
    setBodyScrollLocked(true);
};

const closeModal = (modalEl) => {
    if (!modalEl) return;
    hideModalElement(modalEl);
    openModals.delete(modalEl);
    if (openModals.size === 0) {
        setBodyScrollLocked(false);
    }
};

const initModalAutoHide = () => {
    // Hide all referenced modals initially (unless already open)
    const triggers = document.querySelectorAll('[data-modal]');
    const seen = new Set();
    triggers.forEach((trigger) => {
        const id = trigger.getAttribute('data-modal');
        if (!id || seen.has(id)) return;
        seen.add(id);
        const modal = findModalForTrigger(trigger, id) || document.getElementById(id);
        if (modal && !modal.classList.contains('is-open')) {
            hideModalElement(modal);
        }
    });
};

const isOverlayClick = (modalEl, eventTarget) => {
    if (!modalEl.contains(eventTarget)) return false;
    // If click is outside content area, consider as overlay click
    const content = modalEl.querySelector('[class*="modal-content"]');
    if (!content) {
        // No explicit content element; treat click on modal root as overlay
        return eventTarget === modalEl;
    }
    return !content.contains(eventTarget);
};

const handleDocumentClick = (event) => {
    // OPEN
    const opener = event.target.closest('[data-modal]');
    if (opener) {
        const id = opener.getAttribute('data-modal');
        if (id) {
            event.preventDefault();
            const modal = findModalForTrigger(opener, id);
            if (modal) openModal(modal);
        }
        return;
    }

    // CLOSE via button
    const closer = event.target.closest('[data-modal-close]');
    if (closer) {
        const modal = closer.closest('[id][class*="modal"], [data-modal-root]');
        if (modal) {
            event.preventDefault();
            closeModal(modal);
        }
        return;
    }

    // CLOSE via overlay
    const maybeModal = event.target.closest('[id][class*="modal"], [data-modal-root]');
    if (maybeModal && isOverlayClick(maybeModal, event.target)) {
        event.preventDefault();
        closeModal(maybeModal);
    }
};

const handleKeydown = (event) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
        // Close the most recently opened modal
        const last = Array.from(openModals).pop();
        if (last) {
            event.preventDefault();
            closeModal(last);
        }
    }
};

const initUniversalModals = () => {
    initModalAutoHide();
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleKeydown);
};

document.addEventListener('DOMContentLoaded', initUniversalModals);
export default initUniversalModals;


